const API = process.env.REACT_APP_API_ENDPOINT;
const TOKEN_KEY = "aml_auth_token";
const UID_KEY = "aml_uid";
const PATH_KEY = "aml_path";

export const getAuthToken = () => sessionStorage.getItem(TOKEN_KEY);
export const getStoredUid = () => sessionStorage.getItem(UID_KEY);
export const getStoredPath = () => sessionStorage.getItem(PATH_KEY);

const setAuthToken = (token, uid, pathSegment) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(UID_KEY, uid);
  sessionStorage.setItem(PATH_KEY, pathSegment);
};

export const clearAuthToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(UID_KEY);
  sessionStorage.removeItem(PATH_KEY);
};

const authFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAuthToken()}`,
      ...options.headers,
    },
  });

  if (response.status === 401) {
    clearAuthToken();
    window.dispatchEvent(new Event("token:expired"));
    throw new Error("UNAUTHORIZED");
  }

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.message || "Errore.");
  }

  return response.json();
};

export const service = {
  verifyOtp: async ({ token, otp, pathSegment }) => {
    const response = await fetch(`${API}/api/client/access`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, otp }),
    });

    if (response.status === 401) {
      const err = await response.json();
      throw new Error(err.message || "UNAUTHORIZED");
    }

    if (response.status === 410) {
      throw new Error("LINK_SCADUTO");
    }

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "OTP non valido o scaduto.");
    }

    const data = await response.json();
    setAuthToken(data.access_token, token, pathSegment);
    return data;
  },

  getAmlForm: (uid) => authFetch(`${API}/api/client/aml/form/${uid}`),

  saveAmlForm: (uid, data) =>
    authFetch(`${API}/api/client/aml/save/${uid}`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  submitAmlForm: (uid, data) =>
    authFetch(`${API}/api/client/aml/submit/${uid}`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  generateAmlDocument: (caseId) =>
    authFetch(`${API}/api/client/aml/document/${caseId}/generate`, {
      method: "GET",
    }),

  downloadAmlDocument: async (documentId) => {
    const response = await fetch(
      `${API}/api/client/aml/document/${documentId}/download`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      },
    );
    if (response.status === 401) {
      clearAuthToken();
      window.dispatchEvent(new Event("token:expired"));
      throw new Error("UNAUTHORIZED");
    }
    if (!response.ok) throw new Error("Errore download.");
    return response.blob();
  },

  uploadIdentityDocument: async (formData) => {
    const response = await fetch(
      `${API}/api/client/aml/upload-identity-document`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        body: formData,
      },
    );
    if (response.status === 401) {
      clearAuthToken();
      window.dispatchEvent(new Event("token:expired"));
      throw new Error("UNAUTHORIZED");
    }
    if (!response.ok) throw new Error("Errore upload documento identità.");
    return response.json();
  },

  deleteDocument: async (idDocument) => {
    const response = await fetch(
      `${API}/api/client/aml/delete-identity-document/${idDocument}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      },
    );
    if (response.status === 401) {
      clearAuthToken();
      window.dispatchEvent(new Event("token:expired"));
      throw new Error("UNAUTHORIZED");
    }
    if (!response.ok) throw new Error("Errore eliminazione documento.");

    const text = await response.text();
    return text ? JSON.parse(text) : null;
  },

  uploadAmlSigned: async (formData) => {
    const response = await fetch(`${API}/api/client/aml/upload-aml-signed`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      body: formData,
    });
    if (response.status === 401) {
      clearAuthToken();
      window.dispatchEvent(new Event("token:expired"));
      throw new Error("UNAUTHORIZED");
    }
    if (!response.ok) throw new Error("Errore upload documento firmato.");
    return response.json();
  },

  initConfirmation: async (token) => {
    const response = await fetch(
      `${API}/api/client/aml/confirmations/${token}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.status === 410) throw new Error("LINK_SCADUTO");
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "Errore.");
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  },

  verifyConfirmation: async (token, otp) => {
    const response = await fetch(
      `${API}/api/client/aml/confirmations/${token}/verify`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otp }),
      },
    );
    if (response.status === 401) {
      const err = await response.json();
      throw new Error(err.message || "OTP non corretto.");
    }
    if (response.status === 410) throw new Error("LINK_SCADUTO");
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "Errore.");
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  },

  regenerateToken: async (uid) => {
    const response = await fetch(
      `${API}/api/client/access/regenerate-token/${uid}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "Errore rigenerazione token.");
    }
    return response.json();
  },
};
